import pdf1 from "../assets/pdf/KLG Comprehensive Plan (2021.04.06) - ADOPTED.pdf"
import pdf2 from "../assets/pdf/KLG Downtown Plan (2021.04.06) - ADOPTED.pdf"
import pdf3 from "../assets/pdf/KLG Transportation Plan_v12.pdf"

function Documents() {
    return (
        <div className="container" style={{marginTop: "100px"}}>
            <br/>
            <h2>Documents</h2>
            <h3>Adopted Plans</h3> 
            <ul style={{ listStyle: "none" }}>
                <li><a href={pdf1} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>Adopted Comprehensive Plan</a></li>
                <li><a href={pdf2} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>Adopted Downtown Plan</a></li>
                <li><a href={pdf3} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>Adopted Thoroughfare Plan</a></li>
            </ul>
	    </div>
    );
};

export default Documents;